const IST_OFFSET_MINUTES = 5 * 60 + 30;
const DAY_MINUTES = 24 * 60;

export function nowMinutesIST() {
  const now = new Date();
  return (now.getUTCHours() * 60 + now.getUTCMinutes() + IST_OFFSET_MINUTES) % DAY_MINUTES;
}

function parseStoreTime(time, { allow24 = false } = {}) {
  if (typeof time !== "string" || !/^\d{2}:\d{2}$/.test(time)) return null;
  const [hourText, minuteText] = time.split(":");
  const hours = Number(hourText);
  const minutes = Number(minuteText);
  if (!Number.isInteger(hours) || !Number.isInteger(minutes) || minutes > 59) return null;
  if (hours > 23 && !(allow24 && hours === 24 && minutes === 0)) return null;
  return hours * 60 + minutes;
}

export function hasValidStoreHours(startTime, endTime) {
  return parseStoreTime(startTime) !== null && parseStoreTime(endTime, { allow24: true }) !== null;
}

export function formatStoreTime(time) {
  const minutes = parseStoreTime(time, { allow24: true });
  if (minutes === null) return "";
  const hour = Math.floor(minutes / 60) % 24;
  const minute = String(minutes % 60).padStart(2, "0");
  return `${hour % 12 || 12}:${minute} ${hour >= 12 ? "PM" : "AM"}`;
}

export function isOpen24Hours(startTime, endTime) {
  return startTime === "00:00" && ["00:00", "24:00", "23:59"].includes(endTime);
}

export function isStoreOpen(startTime, endTime, currentMinutes = nowMinutesIST()) {
  if (!hasValidStoreHours(startTime, endTime)) return null;
  if (isOpen24Hours(startTime, endTime)) return true;

  const start = parseStoreTime(startTime);
  const rawEnd = parseStoreTime(endTime, { allow24: true });
  const end = rawEnd === 0 ? DAY_MINUTES : rawEnd <= start ? rawEnd + DAY_MINUTES : rawEnd;
  const current = end > DAY_MINUTES && currentMinutes < start
    ? currentMinutes + DAY_MINUTES
    : currentMinutes;

  return current >= start && current < end;
}

export function getOrderingAvailability({ orderingEnabled, startTime, endTime, currentMinutes } = {}) {
  const timingIsValid = hasValidStoreHours(startTime, endTime);
  const storeIsOpen = timingIsValid
    ? isStoreOpen(startTime, endTime, currentMinutes)
    : null;

  return {
    timingIsValid,
    storeIsOpen,
    orderingEnabled: orderingEnabled === true && (storeIsOpen !== false),
  };
}
